import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loading?: boolean;

  public showLoading(v: boolean): void {
    this.loading = v;
  }

  public get isLoading(): boolean {
    return this.loading ?? false;
  }


  constructor() { }

}
